import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function RequestToCancelPaymentBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const totalAmount = (chatMessage?.rfq?.purchaseAmount ?? 0).toLocaleString(
    'ko'
  );
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble error>
      <PaymentBubble.Title>결제취소 요청 후 대기중입니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={1} />
      <PaymentBubble.Content>
        파트너가 결제취소 요청 승인 시 결제 대금은 자동 환불됩니다. 구체적인
        결제취소 내용은 채팅을 통해 파트너와 상담하세요.
      </PaymentBubble.Content>
      <PaymentBubble.Content>환불 금액 : {totalAmount}원</PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
